module.exports = __webpack_public_path__ + "img/about-1.b6a5ad11.png";